import type { RouteObject } from "react-router-dom";
import { lazy } from "react";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import InternationalStandards from "../pages/international-standards/page";
import TestGuidesPage from "../pages/resources/test-guides/page";
import CertificatesPage from "../pages/resources/certificates/page";
import InquiryPage from "../pages/inquiry/page";

const InternationalStandardsPage = lazy(() => import('../pages/international-standards/page'));
const CertificatesPage = lazy(() => import('../pages/resources/certificates/page'));
const TestGuidesPage = lazy(() => import('../pages/resources/test-guides/page'));
const HazardousLimitsPage = lazy(() => import('../pages/resources/hazardous-limits/page'));
const InquiryPage = lazy(() => import('../pages/inquiry/page'));
const CeoMessagePage = lazy(() => import('../pages/about/ceo-message/page'));
const CompanyInfoPage = lazy(() => import('../pages/about/company-info/page'));
const CompanyHistoryPage = lazy(() => import('../pages/about/company-history/page'));
const ManagementPolicyPage = lazy(() => import('../pages/about/management-policy/page'));
const CertificationsPage = lazy(() => import('../pages/about/certifications/page'));
const OrganizationPage = lazy(() => import('../pages/about/organization/page'));
const BusinessPage = lazy(() => import('../pages/business/page'));
const ProductTestingPage = lazy(() => import('../pages/business/product-testing/page'));
const CertificationPage = lazy(() => import('../pages/business/certification/page'));
const TestingAnalysisPage = lazy(() => import('../pages/business/testing-analysis/page'));
const IndustrySolutionsPage = lazy(() => import('../pages/customer-support/industry-solutions/page'));
const CertificationSupportPage = lazy(() => import('../pages/customer-support/certification-support/page'));
const JewelryTechnicalCenterPage = lazy(() => import('../pages/customer-support/technical-center/jewelry/page'));
const ChildrenBabyTechnicalCenterPage = lazy(() => import('../pages/customer-support/technical-center/children-baby/page'));
const EducationCenterPage = lazy(() => import('../pages/customer-support/education-center/page'));
const RegulationResearchPage = lazy(() => import('../pages/customer-support/regulation-research/page'));
const AnnouncementsPage = lazy(() => import('../pages/announcements/page'));
const IsoCertificationPage = lazy(() => import('../pages/certifications/iso/page'));
const IlacCertificationPage = lazy(() => import('../pages/certifications/ilac/page'));
const CpscCertificationPage = lazy(() => import('../pages/certifications/cpsc/page'));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about/ceo-message",
    element: <CeoMessagePage />,
  },
  {
    path: "/about/management-policy",
    element: <ManagementPolicyPage />,
  },
  {
    path: "/about/company-info",
    element: <CompanyInfoPage />,
  },
  {
    path: "/about/company-history",
    element: <CompanyHistoryPage />,
  },
  {
    path: "/about/certifications",
    element: <CertificationsPage />,
  },
  {
    path: "/about/organization",
    element: <OrganizationPage />,
  },
  {
    path: "/business",
    element: <BusinessPage />,
  },
  {
    path: "/business/testing-analysis",
    element: <TestingAnalysisPage />,
  },
  {
    path: "/business/product-testing",
    element: <ProductTestingPage />,
  },
  {
    path: "/business/certification",
    element: <CertificationPage />,
  },
  {
    path: "/customer-support/industry-solutions",
    element: <IndustrySolutionsPage />,
  },
  {
    path: "/customer-support/certification-support",
    element: <CertificationSupportPage />,
  },
  {
    path: "/customer-support/technical-center/jewelry",
    element: <JewelryTechnicalCenterPage />,
  },
  {
    path: "/customer-support/technical-center/children-baby",
    element: <ChildrenBabyTechnicalCenterPage />,
  },
  {
    path: "/customer-support/education-center",
    element: <EducationCenterPage />,
  },
  {
    path: "/customer-support/regulation-research",
    element: <RegulationResearchPage />,
  },
  {
    path: "/announcements",
    element: <AnnouncementsPage />,
  },
  {
    path: "/international-standards",
    element: <InternationalStandards />,
  },
  {
    path: "/certifications/iso",
    element: <IsoCertificationPage />,
  },
  {
    path: "/certifications/ilac",
    element: <IlacCertificationPage />,
  },
  {
    path: "/certifications/cpsc",
    element: <CpscCertificationPage />,
  },
  {
    path: "/resources/test-guides",
    element: <TestGuidesPage />,
  },
  {
    path: "/resources/certificates",
    element: <CertificatesPage />,
  },
  {
    path: "/resources/hazardous-limits",
    element: <HazardousLimitsPage />,
  },
  {
    path: "/inquiry",
    element: <InquiryPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;